import {LogEntry, LoggerSink, LoggerUtil} from '../../shared/src/Logger.js';

export class BrowserConsoleLogger implements LoggerSink {
    log(entry: LogEntry): void {
        console.log(LoggerUtil.formatSmall(entry));
    }
}
